module.exports = __webpack_public_path__ + "static/media/doctor benifits.71c300c0.png";